import { ref, computed, Ref } from 'vue'
import { ElMessage as message } from 'element-plus'
import cache from '@/plugins/cache'
import { useSite } from '@/store'
import { t, message as messageList } from '@/plugins/i18n'
import { MobileCodeParams } from '@/apis/login'

export const useGetCode = (record: string, fapi: any, PhoneApi: any): any => {
  const disabled = ref(true)
  const loading = ref(false)
  let timer: any = null
  const count = ref(0)

  const tick = () => {
    timer = setInterval(() => {
      count.value--
      if (count.value <= 0) {
        cache.delete(record)
        clearInterval(timer)
      }
    }, 1000)
  }

  const prev = cache.get(record)
  if (prev) {
    if (prev <= 0) {
      cache.get(record)
    } else {
      const value = 60 - Math.ceil((Date.now() - prev) / 1000)
      count.value = value <= 0 ? 0 : value
      count.value > 0 && tick()
    }
  }
  const startCount = () => {
    cache.set(record, Date.now())
    count.value = 60
    tick()
  }

  const getCode = (customerEmail: string, plat = '', api = fapi, ...rest: any): any => {
    // 点击拦截
    let frag = false
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value || frag) {
          message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('邮箱格式不正确，请重新输入'))
          resolve(false)
        } else {
          loading.value = true
          frag = true
          api(customerEmail, ...rest)
            .then((res: any) => {
              loading.value = false
              frag = false
              if (res.success) {
                // message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                console.log(res)
                if (res.code === '24010021') {
                  // plat ? message.error(t('该手机号已被注册，请重新输入', { A: plat })) : message.error(messageList.code[useSite()][res.code])
                  // 不知道为什么要单独处理axios没处理导致提示2次
                  plat ? message.error(t('该手机号已被注册，请重新输入', { A: plat })) : ''
                }
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              frag = false
              console.log(err)
            })
        }
      })
    })
  }

  /** 获取手机号验证码 */
  const getPhoneCode = (params: MobileCodeParams, api = PhoneApi): Promise<boolean> => {
    let frag = false
    return new Promise((resolve) => {
      requestAnimationFrame(() => {
        if (loading.value || frag) {
          message.warning(t('已发送验证码请求，请勿重复发送请求'))
        } else if (disabled.value) {
          message.error(t('请重新输入正确的手机号'))
          resolve(false)
        } else {
          loading.value = true
          frag = true
          api(params)
            .then((res: any) => {
              loading.value = false
              frag = false
              if (res.success) {
                // message.success(t('验证码正在发送，请注意查收'))
                resolve(true)
                startCount()
              } else {
                resolve(false)
              }
            })
            .catch((err: Error): void => {
              loading.value = false
              frag = false
              console.log(err)
            })
        }
      })
    })
  }
  const text = t('已发送')
  const tip = `${text}(${count.value})`
  return { count, tip, disabled, getCode, getPhoneCode }
}

export const useLoading = <T, R>(
  api: (...rest: R[]) => Promise<T>
): [Ref, (...rest: R[]) => Promise<T>] => {
  const loading = ref(false)
  const wrap = async (...rest: R[]): Promise<T> => {
    loading.value = true
    const res = await api(...rest)
    loading.value = false
    return res
  }
  return [loading, wrap]
}
